import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

export default class ErrorContainer extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        {this.props.message}
      </div>
    );
  }
}

ErrorContainer.propTypes = {
  message: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    padding: '12px 15px',
    fontSize: 15,
    lineHeight: 1.4,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    color: Theme.white,
    backgroundColor: Theme.error,

    ':after': {
      bottom: '100%',
      left: 20,
      border: 'solid transparent',
      content: '""',
      height: 0,
      width: 0,
      position: 'absolute',
      pointerEvents: 'none',
      borderColor: 'rgba(232, 94, 94, 0)',
      borderBottomColor: '#E85E5E',
      borderWidth: 10,
      marginLeft: -10,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/ErrorContainer/index.js